export const colors = {
  black1: '#000000',
  background1: '#F0F0F0',
  white1: '#FFFFFF',
  gray1: '#DDDDDD',
  gray2: '#BBBBBB',
  green1: '#0DC98F',
  error1: '#DD634E',
};

export default { colors };
